export default "__VITE_ASSET__CRCtP2eb__"